import React from "react";

const ContactDetailComp = ({ data }) => {
  const isWhatsApp = data?.type?.toUpperCase().includes("WHATSAPP");
  const isPhone =
    !isWhatsApp && /^[\+\d][\d\s\-\(\)]+$/.test(data?.value?.trim());

  const href = isWhatsApp
    ? `https://wa.me/${data?.value?.replace(/[\s\-\(\)\+]/g, "")}`
    : isPhone
    ? `tel:${data?.value?.replace(/\s/g, "")}`
    : data?.link;

  const target = isPhone ? "_self" : "_blank";

  return (
    <a
      href={href}
      className="contact-detail-wrap"
      rel="noreferrer"
      target={target}
    >
      <div className="contact-detail-icon">
        <img src={data?.icon} width={`100%`} height={`100%`} alt={data?.type} />
      </div>
      <div className="contact-detail-txt">
        <h4>{data?.type.replaceAll("_", " ")}</h4>
        <h3>{data?.value}</h3>
      </div>
    </a>
  );
};

export default ContactDetailComp;
